
import {PropType, defineComponent} from 'vue'

type ContainerType = 'General' | 'Tank' | 'Flat Rack' | 'Open Top' | 'Platform' | 'Reefer'
type ColorPaletteItem = {
  text: string
  color: string
  count: number
}

export default defineComponent({
  props: {
    data:  Object as PropType<ColorPaletteItem>,
  },
  computed: {
    typeColor() {
      const typeColors = {
        General: '#007BFF', // Blue
        Tank: '#28A745', // Green
        'Flat Rack': '#FFC107', // Yellow
        'Open Top': '#DC3545', // Red
        Platform: '#6610F2', // Purple
        Reefer: '#17A2B8', // Teal
      };

      return typeColors[this.containerType] || '#6C757D'; // Gray
    },
  },
});
